<script>
    import { updatePrompt, deletePrompt } from '@/api/chatGPT';

    export default {
        computed: {
            isSave() {return this.$store.getters.IS_SAVE_PROMPT_EDIT}
        },
        methods: {
            async save() {
                const editData = this.$store.getters.PROMPT_DATA_EDIT;
                const response = await updatePrompt(editData);
                if (response === true) {
                    this.$store.commit('PROMPTS_UPDATE', {
                        id: editData.id,
                        payload: editData,
                    })
                    await this.close();
                }
            },
            async deleteObj() {
                const editData = this.$store.getters.PROMPT_DATA_EDIT;
                const response = await deletePrompt(editData.id);
                if (response === true) {
                    this.$store.commit('PAG_PROVIDER_SPLICE', editData.id);
                    await this.close();
                }
            },
            async close() {
                this.$store.commit('IS_SHOW_PROMPT_EDIT', false);
            }
        }
    }
</script>


<template>
    <button
        class="button_blue_100"
        :disabled="isSave === false"
        @click="save"
    >Save</button>
    <button
        class="button_blue_100 button_red ml_10"
        @click="deleteObj"
    >Delete</button>
    <button
        class="button_blue_100 close_button mr_10"
        @click="close"
    >Close</button>
</template>